import { createFileRoute } from '@tanstack/react-router';

import { CreativeEditorPage } from '../features/campaigns/creatives/components/CreativeEditor/CreativeEditorPage';
import { creativesRouteSearchSchema } from '../features/campaigns/creatives/creativesRouteSearch';
import { CreativeEditorMode, CreativeTab } from '../features/campaigns/creatives/model';

export const Route = createFileRoute('/campaigns/creatives_/display_/create')({
  validateSearch: creativesRouteSearchSchema,
  component: DisplayCreativeCreateRoute,
});

function DisplayCreativeCreateRoute() {
  const search = Route.useSearch();
  return (
    <CreativeEditorPage
      tab={CreativeTab.Display}
      mode={CreativeEditorMode.Create}
      brandId={search.brand ?? ''}
    />
  );
}
